// apps/mtd-itsa-web/src/hooks/use-hmrc-api.ts
// Hook to provide a fetch wrapper that includes HMRC‑specific headers
import { useAuth } from "@/providers/auth-provider";
import { getTestScenarioHeader } from "../utils/test-headers";
import { useFraudContext } from "./use-fraud-context";

// Allow passing projectId if it's available in the component, or grab it from a store
export function useHmrcApi(currentProjectId?: string) {
    const { user } = useAuth();
    const fraudContext = useFraudContext();

    const customFetch = async (url: string, options: RequestInit = {}) => {
        const headers = {
            "Content-Type": "application/json",
            "x-project-id": currentProjectId || "",
            "x-user-uuid": user?.id || "",
            "x-fraud-context": JSON.stringify(fraudContext),
            ...getTestScenarioHeader(),
            ...options.headers,
        };

        return fetch(url, { ...options, headers });
    };

    return {
        // The raw fetch is still available for edge cases
        fetch: customFetch,

        // Convenience wrapper for GET
        get: (url: string) =>
            customFetch(url, {
                method: "GET",
            }),

        // Convenience wrapper for POST
        post: (url: string, data: any) =>
            customFetch(url, {
                method: "POST",
                body: JSON.stringify(data),
            }),

        // Convenience wrapper for PUT (already existed)
        put: (url: string, data: any) =>
            customFetch(url, {
                method: "PUT",
                body: JSON.stringify(data),
            }),

        // Convenience wrapper for DELETE
        delete: (url: string) =>
            customFetch(url, {
                method: "DELETE",
            }),
    };
}
